import { useEffect, useState } from 'react';
import { agentApi } from '@/services/agentApi';
import { ApplicationDocument, resolveApplicationDocuments } from '@/utils/applicationDocuments';

export function useApplicationDocuments(applicationId: number | null | undefined, metadata: unknown) {
  const [attempt, setAttempt] = useState(0);
  const [request, setRequest] = useState<{
    applicationId: typeof applicationId; metadata: unknown; attempt: number;
    files: ApplicationDocument[]; loading: boolean; error: boolean;
  }>({ applicationId: undefined, metadata: undefined, attempt: -1, files: [], loading: false, error: false });
  useEffect(() => {
    let active = true;
    const identity = { applicationId, metadata, attempt };
    setRequest({ ...identity, files: [], error: false, loading: Boolean(applicationId) });
    if (applicationId) {
      agentApi.getApplicationDocuments(applicationId).then(files => {
        if (active) setRequest({ ...identity, files, error: false, loading: false });
      }).catch(() => {
        if (active) setRequest({ ...identity, files: [], error: true, loading: false });
      });
    }
    return () => { active = false; };
  }, [applicationId, metadata, attempt]);
  // Never render attachments/error state from the preceding application, even
  // during the render before effect cleanup and the replacement fetch run.
  const current = request.applicationId === applicationId && request.metadata === metadata && request.attempt === attempt;
  return {
    ...resolveApplicationDocuments(metadata, current ? request.files : []),
    loading: current ? request.loading : Boolean(applicationId),
    error: current && request.error,
    retry: () => setAttempt(value => value + 1),
  };
}
